export function Spinner({ label }: { label?: string }) {
  return (
    <div className="card" style={{ textAlign: 'center' }}>
      <div className="spinner" aria-hidden="true" />
      {label ? <div style={{ marginTop: 12 }}>{label}</div> : null}
    </div>
  )
}

